import * as React from 'react';
import { Box } from '@mui/system';

interface ILayoutDashboardProps {
    children?: React.ReactNode;
    title: string;
}

export const LayoutDashboard: React.FC<ILayoutDashboardProps> = ({ children, title }) => {

    return (
        <React.Fragment>
            <Box display='flex' flexDirection='column' gap={2} width='100%'>
                <Box flexDirection='column' gap={2} width='100%'>
                    {children}
                </Box>
            </Box>
        </React.Fragment >
    );
};

